<template lang="pug">
    m-list(v-bind="$attrs" v-on="$listeners")
        template(#template="{item, index}")
            e-typography-links-small(class="m-list-effectiveness-option__item")
                | {{item.title}}
            m-list-effectiveness-option-questions(
                :answers="answers"
                :items="item.children"
                v-bind="$attrs"
                :option-section-key="index"
                @click:question="$emit('click:option-question', {...$event, optionSectionKey: index})")
</template>

<script>
    import MList from "@modules/lists/m-list";
    import MListEffectivenessOptionQuestions from '@modules/lists/concrete/m-list-effectiveness-option-questions';

    export default {
        name: "m-list-effectiveness-option",
        components: {MList,
            MListEffectivenessOptionQuestions
        },
        props:{
            answers:{
                type:Array,
                required:true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .m-list-effectiveness-option {
        &__item {
            margin-left: 35px;
            color: #000;
            margin-top: 20px;
            display: block;
        }
        &__icon {
            position: absolute;
            left: -35px;
            top: -2px;
        }
    }
</style>
